// Mapea el estado de un remito a un color y etiqueta consistentes en toda la UI.
export const getEstadoConfig = (estado) => {
  const value = (estado || "").toString().toLowerCase()

  if (value.includes("facturado") ) {
    return { color: "success", label: estado }
  }

  if (value.includes("a facturar")) {
    return { color: "warning", label: estado }
  }

    if (value.includes("anulado")) {
    return { color: "error", label: estado }
  }

  return { color: "default", label: estado || "Sin estado" }
}
